import { provideState } from '@ngrx/store';
import { WAGER_FEATURE_KEY, WagerEffects, WagerFacade, wagerReducer } from './+state';
import { provideEffects } from '@ngrx/effects';

export * from './+state';


export const wagerProviders = [
  // ngrx
  WagerFacade,
  provideState(WAGER_FEATURE_KEY, wagerReducer),
  provideEffects(WagerEffects),
];
